import { USERS, USER_DETAILS, USER_STATUS, USER_STATS } from '../config/api';
import { apiCall } from './api';

// Get all users with optional parameters
export const getUsers = async (params = {}) => {
  try {
    // Use the correct apiCall function signature: apiCall(endpoint, options)
    const response = await apiCall(USERS, {
      method: 'GET',
      // Convert params to query string if needed
      ...(Object.keys(params).length > 0 && { data: params })
    });
    
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch users',
      data: null
    };
  }
};

// Get user by ID
export const getUserById = async (userId) => {
  try {
    const endpoint = USER_DETAILS.replace('{id}', userId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching user:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch user',
      data: null
    };
  }
};

// Create new user
export const createUser = async (userData) => {
  try {
    const response = await apiCall(USERS, {
      method: 'POST',
      data: userData
    });
    return response;
  } catch (error) {
    console.error('Error creating user:', error);
    return {
      success: false,
      error: error.message || 'Failed to create user',
      data: null
    };
  }
};

// Update existing user
export const updateUser = async (userId, userData) => {
  try {
    const endpoint = USER_DETAILS.replace('{id}', userId);
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: userData
    });
    return response;
  } catch (error) {
    console.error('Error updating user:', error);
    return {
      success: false,
      error: error.message || 'Failed to update user',
      data: null
    };
  }
};

// Delete user
export const deleteUser = async (userId) => {
  try {
    const endpoint = USER_DETAILS.replace('{id}', userId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting user:', error);
    return {
      success: false,
      error: error.message || 'Failed to delete user',
      data: null
    };
  }
};

// Get user profile
export const getUserProfile = async () => {
  try {
    const response = await apiCall('/profile', {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch user profile',
      data: null
    };
  }
};

// Update user profile
export const updateUserProfile = async (profileData) => {
  try {
    const response = await apiCall('/profile', {
      method: 'PUT',
      data: profileData
    });
    return response;
  } catch (error) {
    console.error('Error updating user profile:', error);
    return {
      success: false,
      error: error.message || 'Failed to update user profile',
      data: null
    };
  }
};

// Change user password
export const changeUserPassword = async (passwordData) => {
  try {
    const response = await apiCall('/user/change-password', {
      method: 'POST',
      data: passwordData
    });
    return response;
  } catch (error) {
    console.error('Error changing password:', error);
    return {
      success: false,
      error: error.message || 'Failed to change password',
      data: null
    };
  }
};

// Toggle user status (activate/deactivate)
export const toggleUserStatus = async (userId, status) => {
  try {
    const endpoint = USER_STATUS.replace('{id}', userId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error toggling user status:', error);
    return {
      success: false,
      error: error.message || 'Failed to toggle user status',
      data: null
    };
  }
};

// Get user statistics
export const getUserStats = async () => {
  try {
    const response = await apiCall(USER_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching user stats:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch user stats',
      data: null
    };
  }
};

// Login as another user (impersonation)
export const loginAsUser = async (userId) => {
  try {
    const endpoint = `${USER_DETAILS.replace('{id}', userId)}/login-as`;
    const response = await apiCall(endpoint, {
      method: 'POST'
    });
    return response;
  } catch (error) {
    console.error('Error logging in as user:', error);
    return {
      success: false,
      error: error.message || 'Failed to login as user',
      data: null
    };
  }
};
